module.exports = __webpack_public_path__ + "img/logo-spf.2e0b1e0a.svg";